(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.accordion-header').forEach((header) => {
    header.addEventListener('click', () => {
      let parent = header.parentElement;
      let allItems = parent.parentElement.querySelectorAll('.accordion-item');

      // sab close karo
      allItems.forEach((item) => {
        if (item !== parent) {
          item.classList.remove('active');
        }
      });

      // current toggle karo
      parent.classList.toggle('active');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
